
// 获取语言
export const getLang = () => {
  let language = navigator.language.toLowerCase()
  const locallang = getLocalStoragItem('lang') || 'Language'
  if (locallang != null && locallang !=='Language') {
    language = locallang
  }else if(locallang ==='Language'){
    language = 'zh-cn'
  } else {
    switch (language) {
      case 'de-de':
        language = 'de'
        break
      case 'de':
        language = 'de'
        break
      case 'en-us':
        language = 'en-us'
        break
      case 'en':
        language = 'en-us'
        break
      case 'Language':
        language = 'zh-cn'
        break
      default:
        language = 'zh-cn'
        break
    }
  }
  return language
}

export default {
  getLang
}

export const deleteLimitNumber = 10
